'use strict';
/*
 * « Mon appareil » sur les pages familles (action 15 du benchmark, 24/10).
 * Si l'appareil memorise (KrepiteDeviceMemory) figure parmi les valeurs du filtre
 * Modele (metachamp custom.compatible_model_labels, Search & Discovery), une ligne
 * propose de n'afficher que ses pieces, ou de revenir a toute la famille.
 * Aucun filtrage automatique : un clic, une navigation normale (URL partageable).
 * Rien ne s'affiche sans appareil memorise ni quand le modele n'est pas dans la liste.
 * 24/10 : aussi sur la recherche (#main-search-filters) ; le style est injecte ici, une fois,
 * pour servir les deux gabarits sans feuille supplementaire.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var PARAM = 'filter.p.m.custom.compatible_model_labels';
  /* 31/10 (lot collections) : l'action est une puce bascule du systeme (k-puce, active en bois avec
     croix de retrait, aria-pressed), au lieu d'un lien colore. Seule la boite est stylee ici. */
  var CSS = '.k-dff { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 16px; box-sizing: border-box; width: calc(100% - 48px); max-width: calc(var(--k-page-width, 1200px) - 48px); margin: 0 auto 16px; padding: 12px 16px; border: 1px solid var(--k-border); border-radius: var(--k-radius-card, 16px); background: var(--k-white, #fff); color: var(--k-bois); } .k-dff__text { flex: 1 1 260px; margin: 0; font-size: 15px; line-height: 1.45; } .k-dff__text strong { font-weight: 700; } .k-dff .k-puce { padding-top: 1px; padding-bottom: 1px; line-height: 1.25; white-space: normal; text-align: left; } @media (max-width: 749px) { .k-dff { width: calc(100% - 32px); padding: 12px 14px; } }';
  var CROIX = '<svg viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l6 6M9 3 3 9"/></svg>';

  /* Puce bascule : inactive = proposer le filtre, active = retirer le filtre (croix de 12 px dans
     une zone de 32 px). C'est un lien (URL partageable, navigation normale) qui se presente en bouton. */
  function puce(href, libelle, active, retirer) {
    var a = document.createElement('a');
    a.className = active ? 'k-puce k-puce--active k-dff__action' : 'k-puce k-dff__action';
    a.href = href;
    a.setAttribute('role', 'button');
    a.setAttribute('aria-pressed', active ? 'true' : 'false');
    a.appendChild(document.createTextNode(libelle));
    if (active) {
      a.setAttribute('aria-label', retirer);
      var x = document.createElement('span');
      x.className = 'k-puce__retirer k-puce__retirer--deco';
      x.setAttribute('aria-hidden', 'true');
      x.innerHTML = CROIX;
      a.appendChild(x);
    }
    return a;
  }

  function anchorEl() {
    return document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
  }

  function ensureStyle() {
    if (document.getElementById('k-dff-style')) return;
    var st = document.createElement('style');
    st.id = 'k-dff-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function normalize(value) {
    return (value || '').toString().normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function findOption(target) {
    var inputs = document.querySelectorAll('input[name="' + PARAM + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (normalize(inputs[i].value) !== target) continue;
      var label = inputs[i].closest('label') || document.querySelector('label[for="' + inputs[i].id + '"]');
      var m = label && /\((\d+)\)/.exec(label.textContent || '');
      return { value: inputs[i].value, count: m ? parseInt(m[1], 10) : null };
    }
    return null;
  }

  function urlWith(value) {
    var u = new URL(window.location.href);
    u.searchParams.delete(PARAM);
    u.searchParams.delete('page');
    if (value) u.searchParams.append(PARAM, value);
    return u.pathname + u.search;
  }

  /*
   * Recherche (24/10) : la recherche Shopify ne garde, sur un mot seul (« joint »), qu'une partie des
   * resultats avant le filtre Modele (mesure : 1 joint Liva 6 sur 3). Ajouter le nom de l'appareil a la
   * requete (« joint Lotus Liva 6 ») fait remonter les 3 joints en tete. Sur la recherche, on oriente donc
   * la requete au lieu de filtrer, sans annoncer de nombre (il serait faux).
   */
  function searchUrl(q) {
    var u = new URL(window.location.href);
    u.searchParams.set('q', q);
    u.searchParams.delete(PARAM);
    u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  function renderSearch(anchor, old, name) {
    var q = (new URL(window.location.href).searchParams.get('q') || '').trim();
    if (!q) { if (old) old.remove(); return; }
    var nq = normalize(q), nn = normalize(name);
    var oriented = nq.length > nn.length && nq.slice(-nn.length) === nn;
    ensureStyle();
    var el = document.createElement('div');
    el.className = 'k-dff';
    el.setAttribute('role', 'status');
    var text = document.createElement('p');
    text.className = 'k-dff__text';
    var strong = document.createElement('strong');
    strong.textContent = name;
    var link;
    if (oriented) {
      text.appendChild(document.createTextNode('Résultats orientés vers votre '));
      text.appendChild(strong);
      text.appendChild(document.createTextNode('.'));
      link = puce(searchUrl(q.slice(0, q.length - name.length).trim() || q), name, true, 'Retirer le filtre ' + name);
    } else {
      text.appendChild(document.createTextNode('Votre '));
      text.appendChild(strong);
      text.appendChild(document.createTextNode(' : affichez d’abord les pièces qui lui correspondent.'));
      link = puce(searchUrl(q + ' ' + name), 'Voir ses pièces', false);
    }
    el.appendChild(text);
    el.appendChild(link);
    if (old) old.replaceWith(el);
    else anchor.parentNode.insertBefore(el, anchor);
  }

  function render() {
    var anchor = anchorEl();
    var isSearch = anchor && anchor.id === 'main-search-filters';
    var old = document.querySelector('.k-dff');
    var KDM = window.KrepiteDeviceMemory;
    var device = KDM && typeof KDM.get === 'function' ? KDM.get() : null;
    if (!anchor || !device) { if (old) old.remove(); return; }

    var name = device.brand_label + ' ' + device.model_label;
    if (isSearch) { renderSearch(anchor, old, name); return; }
    // 02/11 : la page famille choisit l'appareil en haut (k-choix-appareil) ; pas de second encart.
    if (document.querySelector('[data-k-pa]')) { if (old) old.remove(); return; }
    var target = normalize(name);
    var active = new URL(window.location.href).searchParams.getAll(PARAM);
    var isActive = active.length === 1 && normalize(active[0]) === target;
    var option = isActive ? { value: active[0], count: null } : findOption(target);
    if (!option) { if (old) old.remove(); return; }

    ensureStyle();
    var el = document.createElement('div');
    el.className = 'k-dff';
    el.setAttribute('role', 'status');
    var text = document.createElement('p');
    text.className = 'k-dff__text';
    var strong = document.createElement('strong');
    strong.textContent = name;
    var link;
    if (isActive) {
      text.appendChild(document.createTextNode('Pièces filtrées pour votre '));
      text.appendChild(strong);
      text.appendChild(document.createTextNode('.'));
      link = puce(urlWith(null), name, true, 'Retirer le filtre ' + name);
    } else {
      text.appendChild(document.createTextNode('Votre '));
      text.appendChild(strong);
      var n = option.count;
      var lieu = ' de cette famille ';
      text.appendChild(document.createTextNode(n
        ? ' : ' + n + ' pièce' + (n > 1 ? 's' : '') + lieu + (n > 1 ? 'lui correspondent.' : 'lui correspond.')
        : ' : des pièces' + lieu + 'lui correspondent.'));
      link = puce(urlWith(option.value), 'Voir ses pièces', false);
    }
    el.appendChild(text);
    el.appendChild(link);
    if (old) old.replaceWith(el);
    else anchor.parentNode.insertBefore(el, anchor);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; render(); });
  }

  function init() {
    render();
    var anchor = anchorEl();
    if (anchor && 'MutationObserver' in window) new MutationObserver(schedule).observe(anchor, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
    window.addEventListener('krepite:device-change', schedule);
    window.addEventListener('storage', function (e) { if (!e || e.key === 'krepite_selected_appliance_v1') schedule(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
